module.exports = __webpack_public_path__ + "static/media/illust_marketing_retain.20061618.png";